import React from 'react'
import Menu from '../components/Navbar'
import { Container } from 'react-bootstrap'
// import SliderArtikel from '../components/SliderArtikel'
import Footer from '../components/Footer'
import MortaraBlack from '../img/Mortara-Black.png'
import Swiper from '../components/Swiper'
import Accordion from '../components/Accordion'

// Import Image
import Artikel1 from '../img/aboutus1.png'
import Artikel2 from '../img/aboutus2.png'
import Artikel3 from '../img/aboutus3.png'

// Props Title Left
const Title1 = () => {
  return <p>1. Choose your smart home ecosystem</p>
}
const Title2 = () => {
  return <p>2. Get smart devices</p>
}
const Title3 = () => {
  return <p>3. Install a smart thermostat</p>
}
const Title4 = () => {
  return <p>4. Set up smart lighting</p>
}
const Title5 = () => {
  return <p>5. Improve your home security</p>
}
const Title6 = () => {
  return <p>6. Add smart entertainment</p>
}
const Title7 = () => {
  return <p>7. Personalize your smart home</p>
}

// Props Title Right
const Title8 = () => {
  return <p>1. Start with a plan</p>
}
const Title9 = () => {
  return <p>2. Choose a color scheme</p>
}
const Title10 = () => {
  return <p>3. Experiment with texture</p>
}
const Title11 = () => {
  return <p>4. Don't forget about lighting</p>
}
const Title12 = () => {
  return <p>5. Personalize with accessories</p>
}
const Title13 = () => {
  return <p>6. Edit and declutter</p>
}

// Props Artikel Left
const Article1 = () => {
  return <p>The first step in building your smart home is choosing an ecosystem that you’ll be using to control all of your devices. There are many ecosystems available in the market, such as Amazon Alexa, Google Assistant, Apple HomeKit, and Samsung SmartThings. You can choose the one that suits your needs and preferences.</p>
}
const Article2 = () => {
  return <p>Once you have chosen your ecosystem, you can start acquiring smart devices to integrate with your system. There are smart devices for almost everything, including lighting, temperature control, security, entertainment, and more. You can start with one device and gradually expand your collection as you get more comfortable.</p>
}
const Article3 = () => {
  return <p>One of the best ways to make your home more energy-efficient is by installing a smart thermostat. These devices can automatically adjust the temperature based on your daily routines, and you can also control them from your phone or voice assistant.</p>
}
const Article4 = () => {
  return <p>Smart lighting allows you to control the ambiance of your home and save energy. You can set up schedules and scenes to create the perfect atmosphere for different occasions. You can also control your lights with your voice or phone.</p>
}
const Article5 = () => {
  return <p>Smart home security devices are a great way to improve the safety and security of your home. You can install smart doorbells, security cameras, and smart locks to monitor your home and control access.</p>
}
const Article6 = () => {
  return <p>Smart entertainment devices can enhance your home entertainment experience. You can install smart TVs, sound systems, and media players to stream your favorite movies and TV shows.</p>
}
const Article7 = () => {
  return <p>Once you have installed your devices, you can personalize your smart home by creating routines and scenes that match your daily life. You can automate your morning routine, set up a “movie night” scene, or create a “good night” routine to turn off all the lights and lock the doors.</p>
}

// Props Artikel Left
const Article8 = () => {
  return <p>The first step in building your smart home is choosing an ecosystem that you’ll be using to control all of your devices. There are many ecosystems available in the market, such as Amazon Alexa, Google Assistant, Apple HomeKit, and Samsung SmartThings. You can choose the one that suits your needs and preferences.</p>
}
const Article9 = () => {
  return <p>Once you have chosen your ecosystem, you can start acquiring smart devices to integrate with your system. There are smart devices for almost everything, including lighting, temperature control, security, entertainment, and more. You can start with one device and gradually expand your collection as you get more comfortable.</p>
}
const Article10 = () => {
  return <p>One of the best ways to make your home more energy-efficient is by installing a smart thermostat. These devices can automatically adjust the temperature based on your daily routines, and you can also control them from your phone or voice assistant.</p>
}
const Article11 = () => {
  return <p>Smart lighting allows you to control the ambiance of your home and save energy. You can set up schedules and scenes to create the perfect atmosphere for different occasions. You can also control your lights with your voice or phone.</p>
}
const Article12 = () => {
  return <p>Smart home security devices are a great way to improve the safety and security of your home. You can install smart doorbells, security cameras, and smart locks to monitor your home and control access.</p>
}
const Article13 = () => {
  return <p>Smart entertainment devices can enhance your home entertainment experience. You can install smart TVs, sound systems, and media players to stream your favorite movies and TV shows.</p>
}
const Article14 = () => {
  return <p>Once you have installed your devices, you can personalize your smart home by creating routines and scenes that match your daily life. You can automate your morning routine, set up a “movie night” scene, or create a “good night” routine to turn off all the lights and lock the doors.</p>
}

const Artikel = () => {

  const Image = () => {
    return <img src={Artikel1} alt="" />
  }
  const Image2 = () => {
    return <img src={Artikel2} alt="" />
  }
  const Image3 = () => {
    return <img src={Artikel3} alt="" />
  }

  return (
    <>
      <Menu />
      <Container fluid className="contArtikel">
          <div className="containerArtikel">
            <div className="mortaraArtikel">
              {/* <img src={MortaraBlack} alt="" /> */}
            </div>
            <div className="textArtikel">
              <h1>Some Tips For Build Your Smart Home</h1>
              <p>Building a smart home is easier than ever thanks to the rapid advancement of technology in recent years. A smart home allows you to control and automate various aspects of your living space, such as lighting, temperature, security, and entertainment, all from a single device or platform. In this article, we’ll go over some tips to help you build your smart home.</p>
              <p>
                <Accordion Title={Title1()} Article={Article1()}/>
                <Accordion Title={Title2()} Article={Article2()}/>
                <Accordion Title={Title3()} Article={Article3()}/>
                <Accordion Title={Title4()} Article={Article4()}/>
                <Accordion Title={Title5()} Article={Article5()}/>
                <Accordion Title={Title6()} Article={Article6()}/>
                <Accordion Title={Title7()} Article={Article7()}/>
              </p>
              <p>
                In conclusion, building a smart home is a fun and exciting project that can enhance your quality of life. By following these tips, you can create a smart home that meets your needs and preferences. Remember to choose an ecosystem, get smart devices, install a smart thermostat, set up smart lighting, improve your home security, add smart entertainment, and personalize your smart home.
              </p>
            </div>
            <div className="textArtikel">
              <h1>Interior Design for Your Home: Tips and Tricks</h1>
              <p>Are you looking to give your home a fresh, new look? Interior design can be a fun and rewarding way to personalize your space and make it feel like your own. Whether you're an experienced decorator or just starting out, these tips and tricks can help you create a beautiful and functional home.</p>
              <p>
                <Accordion Title={Title8()} Article={Article8()}/>
                <Accordion Title={Title9()} Article={Article9()}/>
                <Accordion Title={Title10()} Article={Article10()}/>
                <Accordion Title={Title11()} Article={Article11()}/>
                <Accordion Title={Title12()} Article={Article12()}/>
                <Accordion Title={Title13()} Article={Article13()}/>
              </p>
              <p>
                By following these tips, you can create a beautiful and functional home that reflects your personal style. With a little bit of planning and creativity, the possibilities are endless!
              </p>
            </div>
            <div className="embedInstagram mb-5">
              <div className="elfsight-app-b507292a-74b4-4f15-b347-5adc8613d534"></div>
            </div>
          </div>
          {/* <div className="sliderArtikel">
            <Swiper image={Image()} image2={Image2()} image3={Image3()} />
          </div> */}
      </Container>
      <div className="footerArtikel">
        <Footer />
      </div>
    </>   
  )
}

export default Artikel